export default "__VITE_ASSET__4e9cbc67__"